import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, filter } from 'rxjs';
import { environment } from '@environments/environment';
import { map, switchMap, take } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { AppState } from '@store/reducers';
import { selectLocalChannel, selectStore } from '@store/selectors';
import { LocalChannel, Store as StoreModel } from '../../models';
import { IResponseSuccess } from '../../interfaces';
import { LocalChannel as LocalChannelEnum } from '@core/enums';

@Injectable({
  providedIn: 'root',
})
export class LocalChannelService {
  store$: Observable<StoreModel | null>;
  localChannelList$: Observable<LocalChannel[] | null>;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store$ = this.store.select(selectStore);
    this.localChannelList$ = this.store.select(selectLocalChannel);
  }

  getAllLocalCanalByTiendaID(
    sesion?: string
  ): Observable<IResponseSuccess<LocalChannel>> {
    return this.store$.pipe(
      take(1),
      filter((storeData) => !!storeData),
      switchMap((storeData) => {
        const params = {
          // ! TO DO : Revisar porque no se conecta con un canal que no corresponde (JuvoTRACK es el unico registro que recibe cuando se le pasa el paramentro STOCK)
					...(!!sesion && { seccion: sesion }),
          ...(!!storeData && !!storeData.idLocal && { localId: storeData.idLocal }),
				};
          
        return this.http.get<IResponseSuccess<LocalChannel>>(`${environment.microConfiguraciones}/local-canal`, {
          headers: {
            authorization: storeData.apiKey,
          },
          params: {
            ...params
          },
        });
      })
    );
  }

  getJuvOloChannel(): Observable<LocalChannel | null> {
    return this.localChannelList$.pipe(
      take(1),
      filter((localChannelList) => !!localChannelList),
      map((localChannelList) => {
        return localChannelList?.find((LocalChannel)=>LocalChannel.codigo == LocalChannelEnum.JuvoOlo) ?? null
      })
    );
  }
}


